import { render, staticRenderFns } from "./CampaignGroups.vue?vue&type=template&id=e72517d0"
import script from "./CampaignGroups.vue?vue&type=script&lang=js"
export * from "./CampaignGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports